import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { error } from "pdf-lib";
import { Endpoints } from "../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ErrorModal from "../Components/Security/ErrorModal";
import CustomDropdown from "../CustomControls/dropdown";

const AddAppointment = ({ isOpen, onClose, existingData, onRefresh }) => {
  const [time, setTime] = useState(new Date());
  const [date, setDate] = useState(new Date());
  const [providerName, setProviderName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("AccessToken");
  const contract = useSelector((state) => state.userData);
  const userInfo = useSelector((state) => state.userData);
  const [apiErrorMessage, setApiErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const { t, i18n } = useTranslation();
  const devicetype = "PatientPortal";
  const email = useSelector((state) => state.email.email);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [defaultCountry, setDefaultCountry] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
const [cityOptions, setCityOptions] = useState([]);
const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";


  Modal.setAppElement("#root");

  // Helper to parse both "dd-MMM-yyyy" and "MM/dd/yyyy" into Date object
const parseDateFromDatabaseFormat = (dateString) => {
  if (!dateString) return null;
  // Try "dd-MMM-yyyy" (e.g. 25-Sep-2025)
  const dmyRegex = /^([0-9]{2})-([A-Za-z]{3})-([0-9]{4})$/;
  const mdyRegex = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
  let match = dateString.match(dmyRegex);
  if (match) {
    const [, day, monthStr, year] = match;
    const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].indexOf(monthStr);
    if (month === -1) return null;
    const parsedDate = new Date(Number(year), month, Number(day));
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }
  match = dateString.match(mdyRegex);
  if (match) {
    const [, month, day, year] = match;
    const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }
  // Fallback: try Date.parse
  const parsedDate = new Date(dateString);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const formatDateToAPI = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();
  return `${month}/${day}/${year}`;
};

  // Format a Date object to "dd-MMM-yyyy"
  const formatDateToDisplay = (date) => {
    if (!date) return "";
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/\//g, "-");
  };

  // Validation Logic for all fields
  const validateFields = () => {
    const newErrors = {};

    if (!date) newErrors.date = t("datevalidation");
    if (!time) {
      newErrors.time = t("timeval");
    } else {
      const now = new Date();
      now.setSeconds(0, 0); // Normalize seconds and milliseconds
      const selectedTime = new Date(time);
      const selectedDate = new Date(date);

      // Added validation to show error if current time is selected
      const isToday =
        selectedDate.getFullYear() === now.getFullYear() &&
        selectedDate.getMonth() === now.getMonth() &&
        selectedDate.getDate() === now.getDate();

      if (
        isToday &&
        selectedTime.getHours() === now.getHours() &&
        selectedTime.getMinutes() === now.getMinutes()
      ) {
        newErrors.time = "Current time is not allowed.";
      }
    }

    if (!providerName.trim()) newErrors.providerName = t("Providerval");

    if (!isHighmarkPortal) {
    if (!address.trim()) newErrors.address = t("adressval");
    if (!city.trim()) newErrors.city = t("cityval");
    if (!state.trim()) newErrors.state = t("stateval");
    if (!country.trim()) newErrors.country = t("countryval");
    if (!zipCode.trim()) newErrors.zipCode = t("zipval");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //   useEffect(() => {
  //     const fetchStatesAndCountry = async () => {
  //       try {
  //         const response = await axios.post(
  //           Endpoints.StateandCountry,
  //           `_Params=${encodeURIComponent(
  //             JSON.stringify({ Country: userInfo?.userData?.Country, EmailID: email, DeviceType: devicetype })
  //           )}`,
  //           {
  //             headers: {
  //               "Content-Type": "application/x-www-form-urlencoded",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );

  //         if (response.data && response.data.length > 0) {
  //           const states = response.data.map(item => ({ value: item.StateNames, label: item.StateNames }));
  //           setStateOptions(states);

  //         // Always set country based on login user
  // const loggedInCountry = userInfo?.userData?.Country ;
  // setCountry(loggedInCountry);

  //           // If country is not already set (from existing data), update it
  //           if (!country) {
  //             setCountry(loggedInCountry);
  //           }
  //         }
  //       } catch (error) {
  //         console.error("Error fetching states and country:", error);
  //       }
  //     };

  //     fetchStatesAndCountry();
  //   }, []); // Runs only once on component mount

  //Country dropdown fecth logic
  // [UPDATED: Country dropdown fetch logic copied from MapSearch]
useEffect(() => {
  const fetchCountriesAndStates = async () => {
    try {
      const countryParams = {
        EmailID: email,
        DeviceType: devicetype,
      };

      const countryResponse = await axios.post(
        Endpoints.LoadCountry,
        { _Params: JSON.stringify(countryParams) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (countryResponse.data && Array.isArray(countryResponse.data)) {
        const countries = countryResponse.data
          .filter((c) => c.ShortName)
          .map((c) => ({ label: c.ShortName, value: c.ShortName }))
          .sort((a, b) => a.label.localeCompare(b.label));//Sort countries alphabetically
        setCountryOptions(countries);

       
      }

      if (country) {
        const stateParams = {
          Country: country,
          EmailID: email,
          DeviceType: devicetype,
        };

        const stateResponse = await axios.post(
          Endpoints.LoadState,
          { _Params: JSON.stringify(stateParams) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (stateResponse.data && Array.isArray(stateResponse.data)) {
          const states = stateResponse.data.map((item) => ({
            value: item.StateNames,
            label: item.StateNames,
          }))
          .sort((a, b) => a.label.localeCompare(b.label)); // <-- Sort alphabetically
          setStateOptions(states);
        }
      }
    } catch (error) {
      console.error("Error fetching countries/states:", error);
    }
  };

  fetchCountriesAndStates();
}, [country]);

useEffect(() => {
  if (
    isHighmarkPortal &&
    countryOptions.length > 0 &&
    !country // Only set if not already selected
  ) {
    const usaOption = countryOptions.find(
      (opt) =>
        opt.label.toLowerCase() === "united states of america" ||
        opt.value.toLowerCase() === "united states of america"
    );
    if (usaOption) {
      setCountry(usaOption.label);
    }
  }
}, [isHighmarkPortal, countryOptions, country]);

// [UPDATED: City dropdown logic copied from MapSearch]
useEffect(() => {
  const fetchCities = async () => {
    if (!state) return;

    try {
      const params = {
        State: state,
        EmailID: email,
        DeviceType: devicetype,
      };

      const response = await axios.post(
        Endpoints.LoadCity,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && Array.isArray(response.data)) {
        const cities = response.data.map((item) => ({
          label: item.CityNames,
          value: item.CityNames,
        }));
        setCityOptions(cities);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  fetchCities();
}, [state]);


  // Initialize fields with existing data
  useEffect(() => {
    if (existingData) {
      debugger
      // Safely access Time property only if existingData is not null or undefined
      if (existingData.Time && /^[0-2][0-9]:[0-5][0-9]$/.test(existingData.Time)) {
        const [hours, minutes] = existingData.Time.split(":").map(Number);
        const timeValue = new Date();
        timeValue.setHours(hours, minutes, 0, 0);
        setTime(timeValue);
        console.log("Existing time set:", timeValue);
      } else {
       setTime(getFirstValidTime(new Date())); // <-- Use getFirstValidTime here
      }

      setDate(existingData.SelectedDate ? parseDateFromDatabaseFormat(existingData.SelectedDate) : null);
      setProviderName(existingData.ProviderName || "");
      setAddress(existingData.Address || "");
      setCity(existingData.City || "");
      setState(existingData.State || "");
      setCountry(existingData.Country || "");
      setZipCode(existingData.ZipCode || "");
    } else {
      // If existingData is null, initialize the fields
      setTime(getFirstValidTime(new Date())); // <-- set first valid time
      setDate(new Date());
      setProviderName("");
      setAddress("");
      setCity("");
      setState("");
      setCountry("");
      setZipCode("");
    }
  }, [existingData, defaultCountry]);

  const EST_TIME_ZONES = [
  "America/New_York",
  "America/Detroit",
  "America/Indiana/Indianapolis",
  "America/Indiana/Marengo",
  "America/Indiana/Vevay",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Nassau",
  "America/Toronto",
  "America/Montreal",
  "America/Iqaluit",
  "America/Pangnirtung",
  "America/Port-au-Prince",
  "America/Havana",
  "America/Indiana/Petersburg",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Thunder_Bay",
  "America/Cayman",
  "America/Guayaquil",
];

const formatDateToDDMMMYYYY = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = d.toLocaleString("en-US", { month: "short" });
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

  const handleConfirmAppointment = async () => {


    if (!validateFields()) return;
    try {
const systemTimeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let systemTimeZone = Intl.DateTimeFormat('en-US', { timeZoneName: 'long' })
      .formatToParts(new Date())
      .find(part => part.type === 'timeZoneName')?.value || "";

    // If system timezone is in EST_TIME_ZONES, set to "Eastern Standard Time"
    if (EST_TIME_ZONES.includes(systemTimeZoneId)) {
      systemTimeZone = "Eastern Standard Time";
    }

      const formattedSelectedDate = date ? formatDateToDDMMMYYYY(date) : ""; // New selected date
      const formattedSelectedTime = time
        ? `${String(time.getHours()).padStart(2, "0")}:${String(time.getMinutes()).padStart(2, "0")}`
        : ""; // Extract and format hours and minutes


      let params;
      var action; // Declare the action variable here

      if (existingData) {
        // The original date and time for editing purposes
        const editedDate = existingData?.SelectedDate || ""; // Original SelectedDate
        const editedTime = existingData?.Time || ""; // Original SelectedTime


        action = "Edit"; // Set action to "Edit" for rescheduling

        // Construct the payload
        params = {
          SelectedDate: formattedSelectedDate, // New selected date
          SelectedTime: time
    ? time.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
    : "", // Format t // New selected time
          EditedDate: editedDate, // Old SelectedDate (to deactivate in the backend)
          EditedTime: editedTime, // Old SelectedTime (to deactivate in the backend)
          State: state,
          Country: country,
          ProviderName: providerName,
          Action: action, // "Edit" action for rescheduling
          Contract: existingData?.Contract || userInfo?.userData?.ContractIdentified || "",
          Address: address,
          MemberID: userInfo.userData.MemberID,
          ZipCode: zipCode,
          City: city,
          DeviceType: devicetype,
          EmailID: email,
          TimeZoneName: systemTimeZone // <-- Add system time zone here
        };
      } else {
        action = "Save"; // Set action to "Save" for creating a new appointment

        // Construct the payload for "Save"
        params = {
          SelectedDate: formattedSelectedDate, // Date formatted to "dd-MMM-yyyy"
          State: state,
          // Country: country,
          ProviderName: providerName,
          Action: action, // Fixed Action value as per your example
          Contract: userInfo?.userData?.ContractIdentified || "", // Ensuring Contract is passed
          Address: address,
          EditedDate: "", // Empty for "Save" action
          SelectedTime: time
    ? time.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
    : "",
          MemberID: userInfo?.userData?.MemberID || "", // Ensure MemberID exists
          ZipCode: zipCode,
          City: city,
          EditedTime: "",// Empty for "Save" action
          DeviceType: devicetype,
          EmailID: email,
          Country: country,
          TimeZoneName: systemTimeZone // <-- Add system time zone here
        };
      }
      debugger;
      setLoading(true);
      // Make the API request
      const response = await axios.post(
        Endpoints.providerappointment,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`, // Encode the payload as required
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Handle response
      if (response.data.Result === 1) {
        if (response.data.Message ) {
          // Display error for duplicate appointment 
          // setApiErrorMessage(response.data.Message);
          setModalMessage(response.data.Message);
          setShowModal(true);
        } else {
          // Success case
          if (action === "Edit") {
            // Updated here: Set message specifically for rescheduling success case
            setModalMessage("Provider Appointment rescheduled successfully.");
          } else {
            setModalMessage("Provider Appointment saved successfully.");
          }
          //onClose(); // Close the modal
          if (onRefresh) onRefresh();
          navigate("/appointment-cancellation-reschedule"); // Redirect to the appointment list page
        }
      } else {
        // Check for specific failure message and set modal message accordingly
        setModalMessage(response.data.Message || t("Failed to save appointment."));
      }
      setShowModal(true);
    }
    catch (error) {
      console.error(`Error while trying to ${action?.toLowerCase()} appointment:`, error);
      alert(`An error occurred while trying to ${action?.toLowerCase()} the appointment. Please try again.`);
    } finally {
      setLoading(false); // Ensure the loading state is reset after the operation
    }
  };

  // Disable past times for the current date
  const disablePastTimes = (time) => {
    const selectedDate = new Date(date);
    const now = new Date();
    now.setSeconds(0, 0); // Remove seconds and milliseconds for accurate comparison

    // Check if the selected date is today
    const isToday =
      selectedDate.getFullYear() === now.getFullYear() &&
      selectedDate.getMonth() === now.getMonth() &&
      selectedDate.getDate() === now.getDate();

    if (isToday) {
      // Disable times that are in the past for today
      return time > now;
    }

    // Enable all times for future dates
    return true;
  };
const getFirstValidTime = (date) => {
  const now = new Date();
  let candidate = new Date(date);
  candidate.setSeconds(0, 0);

  // If today, start from now, else start from 00:00
  if (
    candidate.getFullYear() === now.getFullYear() &&
    candidate.getMonth() === now.getMonth() &&
    candidate.getDate() === now.getDate()
  ) {
    candidate.setHours(now.getHours(), now.getMinutes(), 0, 0);
    // Round up to next 30-min interval
    const minutes = candidate.getMinutes();
    candidate.setMinutes(minutes % 30 === 0 ? minutes : minutes + (30 - (minutes % 30)), 0, 0);
    if (candidate < now) candidate.setTime(now.getTime());
  } else {
    candidate.setHours(0, 0, 0, 0);
  }
  return candidate;
};


  const CustomTimeInput = ({ value, onClick }) => {
    //const formattedValue = value.replace(/\sAM|PM/g, ""); // Remove AM/PM
    return (
      <input
        type="text"
        className="form-control win-form-control-c clock-control mobile-view"
        value={value}
        readOnly
        onClick={onClick}
      />
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="tracker-modal-content"
      overlayClassName="tracker-modal-overlay"
      shouldCloseOnOverlayClick={false}
    >
      <h2>{t('rescheduleapt')}</h2>
      <div className="model-form-wrapper">
        {loading ? (
           <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
        ) : (
          <>
            {/* Date Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label mandatory">{t('date')}</label>
              <div className="col-sm-6">
                <DatePicker
                  selected={date}
                  onChange={(selectedDate) => {
                    setDate(selectedDate);
                    setApiErrorMessage("");
                    if (selectedDate) {
                      setErrors((prevErrors) => ({ ...prevErrors, date: "" })); // Clear date error
                    }
                  }}
                  dateFormat="MM/dd/yyyy"   // ✅ show as 09/21/2025
                  className={`form-control win-form-control-c calendar-control mobile-view ${errors.date ? "is-invalid" : ""
                    }`}
                  minDate={new Date()} //prevent
                  onKeyDown={(e) => e.preventDefault()} // Restrict typing
                />
                {/* Error Message */}
                {errors.date && (
                  <div className="invalid-feedback d-block">{errors.date}</div>
                )}
              </div>
            </div>

            {/* Time Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label mandatory">{t('time')}</label>
              <div className="col-sm-6">
                <DatePicker
                  selected={time}
                  onChange={(selectedTime) => {
                    setTime(selectedTime);
                    setApiErrorMessage("");
                    if (selectedTime) {
                      setErrors((prevErrors) => ({ ...prevErrors, time: "" }))

                    }
                  }}
                  showTimeSelect
                  showTimeSelectOnly
                  filterTime={disablePastTimes}
                  timeIntervals={30}
                  timeCaption="Time"
                  dateFormat="h:mm aa" // Dropdown will show in 12-hour format with AM/PM
                  timeFormat="h:mm aa" // Ensure time picker follows same format with AM/PM
                  customInput={<CustomTimeInput />}
                  // Use custom input to format display
                  className={`form-control win-form-control-c calendar-control mobile-view ${errors.time ? "is-invalid" : ""}`}
                />
                {errors.time && (<div className="form-field-error-message">{errors.time}</div>)}
              </div>
            </div>


            {/* Provider Name Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label mandatory">{t('providernamee')}</label>
              <div className="col-sm-6">
                <input
                  type="text"
                  className={`form-control win-form-control-c  mobile-view ${errors.providerNme ? "is-invalid" : ""}`}
                  placeholder="Enter provider name"
                  value={providerName}
                  onChange={(e) => {
                    setProviderName(e.target.value);
                    if (e.target.value.trim()) {
                      setErrors((prevErrors) => ({ ...prevErrors, providerName: "" }));
                    }
                  }}
                />
                {errors.providerName && (<div className="form-field-error-message">{errors.providerName}</div>)}
              </div>
            </div>

            {/* Country Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label">{t('Country')}</label>
              <div className="col-sm-6 custom-dropdown-forced-380px-in-tab custom-dropdown-100pc-only-mobile">
              <CustomDropdown
      options={countryOptions.map((opt) => opt.label)}
      selectedOption={country}
      onChange={(val) => {
        setCountry(val);
        setErrors((prevErrors) => ({ ...prevErrors, country: "" }));
        setState(""); // Clear state on country change
        setStateOptions([]); // Clear state dropdown until reloaded
        setAddress("");      // Clear street address
        setCity("");         // Clear city
        setZipCode("");  
      }}
      searchable={true}
      placeholder="Select Country"
       disabled={isHighmarkPortal}
    />
    {errors.country && <div className="form-field-error-message">{errors.country}</div>}
  </div>
</div>

            {/* State Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label">{t('State')}</label>
              <div className="col-sm-6 custom-dropdown-forced-380px-in-tab custom-dropdown-100pc-only-mobile">
                <CustomDropdown
                  options={stateOptions.map((opt) => opt.label)}
                  selectedOption={state}
                  onChange={(val) => {
                    setState(val);
                    setErrors((prevErrors) => ({ ...prevErrors, state: "" }));
                    setCity("");         // Clear city
                    setZipCode(""); 
                  }}
                  searchable={true}
                  placeholder="Select State"
                  disabled={false}
                />
                {errors.state && <div className="form-field-error-message">{errors.state}</div>}
              </div>
            </div>
            {/* City Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label">{t('city')}</label>
              <div className="col-sm-6 custom-dropdown-forced-380px-in-tab custom-dropdown-100pc-only-mobile">
    <CustomDropdown
      options={cityOptions.map((opt) => opt.label)}
      selectedOption={city}
      onChange={(val) => {
        setCity(val);
        setErrors((prevErrors) => ({ ...prevErrors, city: "" }));
        setZipCode("");
      }}
      searchable={true}
      placeholder="Select City"
      disabled={false}
    />
    {errors.city && <div className="form-field-error-message">{errors.city}</div>}
  </div>
</div>


            {/* Address Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label">{t('streetadd')}</label>
              <div className="col-sm-6">
                <input
                  type="text"
                  pattern=".*" // Disable browser validation
                  className={`form-control win-form-control-c mobile-view ${errors.address ? "is-invalid" : ""}`}
                  placeholder="Enter street address"
                  value={address}
                  onChange={(e) => {
                    setAddress(e.target.value);
                    if (e.target.value.trim()) {
                      setErrors((prevErrors) => ({ ...prevErrors, address: "" }));
                    }
                  }}
                />
                {errors.address && <div className="form-field-error-message">{errors.address}</div>}
              </div>
            </div>


            {/* Zip Code Field */}
            <div className="mb-4 row align-items-center">
              <label className="col-sm-4 model-form-label">{t('zipcode')}</label>
              <div className="col-sm-6">
                <input
                  type="text"
                  className={`form-control win-form-control-c mobile-view ${errors.zipCode ? "is-invalid" : ""
                    }`}
                  placeholder="Enter ZIP code"
                  value={zipCode}
                  onChange={(e) => {
                    //const filteredValue = e.target.value.replace(/[^0-9a-zA-Z]/g, "");
                     let filteredValue = e.target.value;
                      // Only allow numbers for USA
                      if (country === "United States of America") {
                        filteredValue = filteredValue.replace(/[^0-9]/g, "");
                      } else {
                        filteredValue = filteredValue.replace(/[^0-9a-zA-Z]/g, "");
                      }
                    setZipCode(filteredValue);
                    if (e.target.value.trim()) {
                      setErrors((prevErrors) => ({ ...prevErrors, zipCode: "" }));
                    }
                  }}
                />
                {errors.zipCode && (
                  <div className="form-field-error-message">{errors.zipCode}</div>
                )}
                {/* Error Message */}

              </div>
            </div>


            <div className="mb-4 row">
              <div className="col-sm-4"></div>
              <div className="col-sm-8">
                {apiErrorMessage && (
                  <div className="form-field-error-message">{apiErrorMessage}</div>
                )}
              </div>
            </div>

            {/* Buttons */}
            <div className="mb-4 row">
              <div className="col-sm-4"></div>
              <div className="col-sm-8">
                <button
                  onClick={onClose}
                  className="win-btn-secondary model-popup-btn me-3 mb-3 mb-sm-0"
                >
                  {t('Cancel')}
                </button>
                <button
                  onClick={handleConfirmAppointment}
                  className="win-btn-primary model-popup-btn"
                >
                  {t('cofirmappontment')}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <ErrorModal show={showModal}
        message={modalMessage}
        onClose={() => {
          setShowModal(false);  // First, close the success modal
          if (onRefresh) onRefresh();  // Call onRefresh to trigger fetchAppointments
          navigate("/appointment-cancellation-reschedule"); // Then navigate
          onClose();  // Then close the main appointment modal
        }} />
    </Modal>
  );
};

export default AddAppointment;
